// @flow

import {
  BRANCH,
} from 'hfty-model-recommendations'

export default {
  [BRANCH]: {},
}
